'use strict'

const geocode = require('./geocode');
const addressModel = require('./addressModel');
var formValidation = require('../../components/formValidation');
const { initPostalCodeValidation, getAddressFormatted } = require('../../util/addressForm');
const addressValidation = require('../../util/addressValidation');
const addressForm = require('../../addressForm');
const addressMap = require('./addressMap');
const googleMapsUtil = require('./googleMapsUtil');
const recipientProfileData = require('../recipientProfileData');

let $modal = null;
let $modalMainTabsContent = null;
let $addEditAddressTabContent = null;
let $addEditAddressForm = null;
let $notificationContainer = null;
let $notificationMessage = null;
let coords = {};

/**
 * Clears the coordinates object
 * @returns {void}
 */
function clearCoordinates() {
    coords = {};
}

function disableCustomAttrTextFields(state){
    const $neighborhoodTxt = $addEditAddressForm.find('.neighborhoodTxt');
    const $cityTxt = $addEditAddressForm.find('.cityTxt');
    const $stateTxt = $addEditAddressForm.find('.stateTxt');

    $neighborhoodTxt.prop('disabled', state);
    $cityTxt.prop('disabled', state);
    $stateTxt.prop('disabled', state);
}

function ResetShippingMethodsModalTabState() {
    $('.modal-address-form').data('is-invalid-edit', false);
    $addEditAddressTabContent.addClass('closing').removeClass('show');

    setTimeout(() => {
        $modalMainTabsContent.removeClass('d-none');
        $addEditAddressTabContent.addClass('d-none').removeClass('closing');
        $addEditAddressForm.empty();
    }, 300);
}

function ShowAddEditAddressTabContent(response, showErrors) {
    $addEditAddressForm.append(response);
    $('.modal-address-form').data('is-invalid-edit', !!showErrors);
    $modalMainTabsContent.addClass('d-none');
    $addEditAddressTabContent.removeClass('d-none');
    void $addEditAddressTabContent[0].offsetWidth;
    $addEditAddressTabContent.addClass('show');

    const $formControls = $addEditAddressForm.find('.form-control');
    $(document).trigger('initDynamicForm', [$formControls]);
    addressMap.showFromContainer($addEditAddressForm.find('.modal-address-form'));

    if (showErrors) {
        var $form = $addEditAddressForm.find('.modal-address-form');
        addressValidation.highlightInvalidFields($form);
    }

    // Essential setup for the injected form; shared by the add and edit flows
    // and independent of Google.
    const $addressForm = $addEditAddressForm.find('.modal-address-form');
    addressValidation.initAddressForm($addressForm, 'account');
    addressForm.initFormValidation($addressForm);
    addressForm.initSuggestionReset($addressForm, function () {
        addressMap.hide($addressForm);
    });

    // Google-dependent init runs last and is a no-op when Places is unavailable,
    // so it never interrupts the setup above.
    initAutocomplete();
    
    recipientProfileData.initForm($addEditAddressForm.find('.modal-address-form'));
}

function handleShowAddAddressTabClick(e) {
    const addAddressUrl = $(this).data('add-address-url');
    $modal.spinner().start();

    e.preventDefault();
    clearCoordinates();

    $.ajax({
        url: addAddressUrl,
        method: 'GET',
        success: function (response) {
            $modal.spinner().stop();
            ShowAddEditAddressTabContent(response);
        },
        error: function (xhr, status, error) {
            $modal.spinner().stop();
            console.error('Error al cargar la dirección');
        }
    });
}

function handleEditAddressClick(e) {
    e.preventDefault();

    clearCoordinates();
    var $card = $(this);
    var selectedAddress = $card.data('address-info');
    var editAddressUrl = $card.data('edit-address-url');
    var showErrors = $card.hasClass('address-invalid');
    $modal.spinner().start();
    $.ajax({
        url: editAddressUrl,
        data: { addressId: selectedAddress.name },
        method: 'GET',
        success: function (response) {
            $modal.spinner().stop();
            ShowAddEditAddressTabContent(response, showErrors);
        },
        error: function (xhr, status, error) {
            $modal.spinner().stop();
            // Error loading address
        }
    });
}

async function handleAddEditAddressCall($form) {

    $form.find('#zipCode, #city, #state').filter(':disabled').attr('data-disabled', 'true');

    disableCustomAttrTextFields(false);

    let url = $form.attr('action');

    $form.find('#zipCode, #city, #state').filter('[data-disabled="true"]').prop('disabled', false);

    const located = await addressForm.validateAndLocateAddress($form);

    $form.find('#zipCode, #city, #state').filter('[data-disabled="true"]')
        .prop('disabled', true)
        .removeAttr('data-disabled');

    if (!located) {
        return;
    }

    const formData = located.formData;
    if (located.place) {
        coords = { lat: located.place.geometry.location.lat(), lng: located.place.geometry.location.lng() };

        const hasCoverage = await addressForm.checkAddressCoverage(located.place, $form);
        if (!hasCoverage) {
            return;
        }

        addressForm.appendFormCoordinates(formData, coords);

        clearErrors();

        $modal.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $.param(formData),
            success: function (data) {
                if (!data.success) {
                    $modal.spinner().stop();
                    formValidation($form, data);
                } else {
                    if (data.setDefault) {
                        $('.modal-address-form').data('is-invalid-edit', false);
                        $(document).trigger('handleSelectAndRenderSelectedDeliveryAddress', data.address);

                        return;
                    }

                    if ($('.modal-address-form').data('is-invalid-edit')) {
                        $(document).trigger('handleInitSavedAddressesSection', data.address.name);
                        $('.modal-address-form').data('is-invalid-edit', false);
                    } else {
                        $(document).trigger('handleInitSavedAddressesSection');
                    }

                    ResetShippingMethodsModalTabState();
                    $modal.spinner().stop();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $modal.spinner().stop();
            }
        });
    }
}

/**
 * Removes informative errores
 * @requires jQuery
 * @returns {void}
 */
function clearErrors() {
    $notificationMessage.text('');
    $notificationContainer.addClass('d-none');
}

/**
* HandleDeliveryPlaceChanged
* @requires jQuery
* @param {Object} autocomplete Google autocomplete
* @returns {void}
**/
function handleDeliveryPlaceChanged (autocomplete) {
    clearErrors();
    const place = autocomplete.getPlace();

    addressMap.showFromPlace($addEditAddressForm.find('.modal-address-form'), place);

    if (place.geometry) {
        coords = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        };
        if (place.address_components) {
            const addressDetails = addressModel.getAddressComponents(place);
            addressForm.autofillInputs($addEditAddressForm.find('.modal-address-form'), addressDetails, true);
        }
    }
    else {
        showError($deliveryInput.attr('data-error-geometry'));
    }
}

/**
 * Function to get the selected delivery address based on the global address details.
 * @param {Object} globalAddressDetails - The global address details object containing geometry and address components.
 * @returns {Object|null} The selected delivery address object, or null if geometry is not available.
 */
function getSelectedDeliveryAddressModel(globalAddressDetails) {
    const selectedDeliveryAddress = getAddressFormatted(globalAddressDetails);

    if (!selectedDeliveryAddress) {
        showError($deliveryInput.attr('data-error-geometry'));
    }

    return selectedDeliveryAddress;
}

/**
    * This function starts the engine for the autocomplete suggestions in the delivery address input
    * @requires jQuery
    * @returns {void}
    **/
function initAutocomplete() {
    // Skip autocomplete when Google Places is unavailable: geocode.initAutocomplete
    // would throw and abort the form setup that follows.
    if (!googleMapsUtil.isPlacesScriptLoaded()) {
        return;
    }

    geocode.initAutocomplete($addEditAddressForm.find('#address1'), handleDeliveryPlaceChanged);
}

function initTabsControls () {
    const btnBack = $addEditAddressTabContent.find('.add-address-btn-back');
    btnBack.on('click', function () {
        ResetShippingMethodsModalTabState();
    });

    $addEditAddressTabContent.find('.btnClose').on('click', function() {
        ResetShippingMethodsModalTabState();
        $(document).trigger('handleShippingMethodsModalClose');
    });

    //inits postal code listener

    $(document).on('submit', 'form.modal-address-form', function (e) {
        var $form = $(this);
        e.preventDefault();

        handleAddEditAddressCall($form);

        return false;
    })

    $(document).on('keyup', '.modal-address-form input[type="text"], .modal-address-form input[type="tel"], .modal-address-form textarea', function () {
        var $form = $(this).closest('form');

        addressForm.clearCoverageErrorOnEdit($form);
    });

    initPostalCodeValidation($addEditAddressForm);
}

/**
 * Initialize the delivery tab
 * @requires jQuery
 * @param {jQuery} $modal modal jquery object
 * @returns {void}
 */
function initTab($mainModal) {
    $modal = $mainModal;
    $modalMainTabsContent = $modal.find('.modal-main-content.shipping-methods');
    $addEditAddressTabContent = $modal.find('.modal-main-content.addoredit-address-content');
    $addEditAddressForm = $addEditAddressTabContent.find('.address-form-section');
    $notificationContainer = $addEditAddressTabContent.find('.notification--error').first();
    $notificationMessage = $addEditAddressTabContent.find('.notification-message').first();

    initTabsControls();
}

module.exports = {
    initTab,
    initAutocomplete,
    handleShowAddAddressTabClick,
    handleEditAddressClick,
    getSelectedDeliveryAddressModel,
};
